var noop = function noop() {};

export default noop;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/utils/noop.js
// module id = 132
// module chunks = 0